<template>
  <el-form
    ref="ruleForm"
    :model="formData"
    label-width="0"
    class="demo-ruleForm error-form"
    size="small"
  >
    <el-table
      :data="formData.arr"
      border
    >
      <!-- 费用类型 -->
      <el-table-column :label="$t('basicData.ExpenseType')" width="200">
        <template slot-scope="scope">
          <el-form-item :prop="`arr.${scope.$index}.feeTypeCode`">
            <el-select
              v-model="scope.row.feeTypeCode"
              :placeholder="$t('basicData.PleaseSelect')"
              style="width: 100%;"
            >
              <el-option
                v-for="item in feeTypeList"
                :key="item.id"
                :label="item.displayName + '(' + item.code + ')'"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-table-column>

      <!-- 特殊规则 -->
      <el-table-column :label="$t('receivablePayable.specialRules')" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.type === 1">
            <el-form-item
              :prop="`arr.${scope.$index}.overWeight`"
              :rules="{ required: scope.row.feeTypeCode, suffix: 3, negative: '', validator: weightType, trigger: ['blur', 'change'] }"
            >
              <div class="tas">
                <div class="label">{{ $t('GlobalSetObj.weight') }}></div>
                <el-input v-model="scope.row.overWeight" />
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item
              :prop="`arr.${scope.$index}.overSize`"
              :rules="{ required: scope.row.feeTypeCode, suffix: 3, negative: '', validator: weightType, trigger: ['blur', 'change'] }"
            >
              <div class="tas">
                <div class="label">{{ $t('receivablePayable.lengthWidthHeightCm') }}></div>
                <el-input v-model="scope.row.overSize" />
              </div>
            </el-form-item>
          </div>
        </template>
      </el-table-column>

      <!-- 价格 -->
      <el-table-column :label="$t('basicData.Price')" min-width="180">
        <template v-slot="scope">
          <div v-if="scope.row.type === 1">
            <el-form-item
              :prop="`arr.${scope.$index}.overWeightExtraPrice`"
              :rules="{ required: scope.row.feeTypeCode, suffix: 3, negative: '', validator: weightType, trigger: ['blur', 'change'] }"
            >
              <el-input v-model="scope.row.overWeightExtraPrice" />
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item
              :prop="`arr.${scope.$index}.overSizeExtraPrice`"
              :rules="{ required: scope.row.feeTypeCode, suffix: 3, negative: '', validator: weightType, trigger: ['blur', 'change'] }"
            >
              <el-input v-model="scope.row.overSizeExtraPrice" />
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { cloneDeep } from 'lodash-es';

/** @typedef {import('./types').TTableRow} TTableRow */

export default {
  name: '',

  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    // 校验
    const weightType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.package !== null && rule.package !== '' && rule.package !== undefined) {
              if (rule.negative1 === 2) {
                if (parseFloat(value) <= parseFloat(rule.package)) {
                  console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package));
                  return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
                } else if (parseFloat(value) <= 0) {
                  return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
                }
              } else {
                if (parseFloat(value) >= parseFloat(rule.package)) {
                  return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
                } else {
                  return callback();
                }
              }
            }
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value !== null && value !== '' && value !== undefined) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$i18n.t('basicData.IncorrectFormatting'))); // '格式不正确'
          } else {
            this.adopt = true;
            if (rule.negative1 === 2) {
              if (parseFloat(value) <= parseFloat(rule.package)) {
                console.log(parseFloat(value), parseFloat(rule.package), parseFloat(value) <= parseFloat(rule.package), '//////////////');
                return callback(new Error(this.$i18n.t('basicData.MustGreaterThanStartingValue'))); // 必须大于起始值
              } else if (parseFloat(value) <= 0) {
                return callback(new Error(this.$i18n.t('basicData.MustBeGreaterThan0'))); // 必须大于0
              }
            } else {
              if (parseFloat(value) >= parseFloat(rule.package)) {
                return callback(new Error(this.$i18n.t('basicData.MustLessThanEndValue'))); // 必须小于结束值
              } else {
                return callback();
              }
            }
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$i18n.t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };

    return {
      formData: {
        /** @type {TTableRow[]} */
        arr: []
      },
      weightType
    };
  },

  watch: {
    'tableData': {
      handler(val, oldVal) {
        if (val.length === 0 && oldVal.length === 0) {
          return;
        }

        // 新的值与旧的值一样
        if (JSON.stringify(val) === JSON.stringify(this.formData.arr)) {
          // console.log('新的值与旧的值一样');
          return;
        }
        // console.log(123987, val);
        this.formData.arr = cloneDeep(this.tableData);
        // this.formData.arr.push(val);
      },
      immediate: true
    },

    // 将数据传给父组件
    formData: {
      handler(val, oldVal) {
        // console.log('子组件提交');
        if (!oldVal || !val) {
          return;
        }
        // console.log('父元素提交', val.arr);
        this.$emit('change', val.arr);
      },
      deep: true
      // immediate: true
    }
  },

  created() {

  },

  methods: {
    // 提交校验
    submitForm() {
      return this.$refs['ruleForm'].validate().then(() => {
        return true;
      }).catch(res => {
        return false;
      });
    },

    // 删除
    handleDel(index) {
      this.formData.arr.splice(index, 1);
    }
  }

};
</script>

<style  scoped>
.demo-ruleForm /deep/ .el-form-item__error {
  position: static !important;
}

.tas {
  display: flex;
  width: 100%;
}
.tas .label {
  width: 150px;
  padding-right: 10px;
  text-align: end;
}
</style>
